import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTenant } from '@/hooks/useTenant';
import { resolveStoreName } from '@/lib/display';
import { isMarketplaceTheme } from '@/lib/marketplace';
import { getStoreCapabilities } from '@/lib/accountType';
import MarketplaceSellersTag from '@/components/feature/template-tags/MarketplaceSellersTag';
import MarketplaceSearchTag from '@/components/feature/template-tags/MarketplaceSearchTag';

export default function VendeursPage() {
  const { tenant, theme } = useTenant();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    document.title = 'Nos vendeurs';
    setReady(true);
  }, []);

  const storeName = resolveStoreName(tenant, theme);
  const marketplace =
    isMarketplaceTheme(theme) || getStoreCapabilities(tenant?.type, tenant?.typecompte).marketplace;

  return (
    <div className="min-h-screen bg-background-50">
      {/* Hero */}
      <section className="relative py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-background-100/60 to-transparent"></div>
        <div className="relative w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-semibold uppercase tracking-wider mb-3">
              <i className="ri-store-2-line"></i>
              Marketplace
            </span>
            <h1 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
              Nos vendeurs
            </h1>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              Découvrez les boutiques et professionnels présents sur {storeName}.
            </p>
          </div>

          {/* Recherche marketplace */}
          {marketplace && (
            <div className="max-w-3xl mx-auto">
              <MarketplaceSearchTag placeholder="Rechercher une boutique, un vendeur..." />
            </div>
          )}
        </div>
      </section>

      {/* Liste des vendeurs */}
      <section className="pb-12 md:pb-16">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          {ready && <MarketplaceSellersTag />}
        </div>
      </section>

      {/* CTA devenir vendeur */}
      {marketplace && (
        <section className="pb-16">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="rounded-2xl bg-accent-500/10 border border-accent-500/20 p-6 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent-500 flex items-center justify-center flex-shrink-0">
                  <i className="ri-store-2-line text-xl text-background-50"></i>
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-bold font-heading text-foreground-950 mb-1">
                    Vous voulez vendre ici ?
                  </h3>
                  <p className="text-sm text-foreground-600 max-w-md">
                    Créez votre compte vendeur et proposez vos produits sur {storeName}.
                  </p>
                </div>
              </div>
              <Link
                to="/vendeur/inscription"
                className="px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-semibold whitespace-nowrap no-underline hover:bg-accent-600 transition-colors"
              >
                Devenir vendeur
              </Link>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}